import React, { useRef } from 'react';
import ReactDOM from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import Backdrop from './backDrop';

import './userModal.css';

const ModalOverLay = React.forwardRef((props, ref) => {
  const content = (
    <main ref={ref} className={`UserModal ${props.className}`} style={props.style}>
        <div className={`UserModal-container ${props.containerClass}`}>
            <div className={`UserModal-content ${props.contentClass}`}>
                {props.children}
            </div>
        </div>
    </main>
  );
  return ReactDOM.createPortal(content, document.getElementById('UserModal-hook'))
});

const UserModal = (props) => {
    const nodeRef = useRef(null);
    return (
        <React.Fragment>
            {props.show && <Backdrop onClick={props.onCancel}/>}
            <CSSTransition
              in={props.show}
              mountOnEnter
              unmountOnExit
              timeout={2}
              classNames='UserModal'
              nodeRef={nodeRef}>
                <ModalOverLay {...props} ref={nodeRef}/>
            </CSSTransition>
        </React.Fragment>
    )
}
export default UserModal;